import { render, staticRenderFns } from "./certifList.vue?vue&type=template&id=26ec77b4&scoped=true"
import script from "./certifList.vue?vue&type=script&lang=js"
export * from "./certifList.vue?vue&type=script&lang=js"
import style0 from "./certifList.vue?vue&type=style&index=0&id=26ec77b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26ec77b4",
  null
  
)

export default component.exports